import React, { useLayoutEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import SwipeableTabView, { IScene } from '@/components/TabView/SwipeableTabView';
import QuestionListItem from '@/containers/ina/index/QuestionListItem';
import MyQuestionListItem from '@/containers/ina/index/MyQuestionListItem';
import { IInAList } from '@/models/ina';
import { THEME_COLORS } from '@/styles/theme';

const QuestionList = ({ inaList }: { inaList?: IInAList }) => {
    const router = useRouter();
    const [currentTab, setCurrentTab] = useState(1);
    const [isLoadMoreData, setIsLoadMoreData] = useState(false);

    useLayoutEffect(() => {
        if (router.query.category) {
            setCurrentTab(Number(router.query.category));
        }
    }, [router.query]);

    const renderScene: IScene[] = [
        {
            key: 'tab0',
            label: '내질문보기',
            page: props => MyQuestionListItem({ ...props, setIsLoadDataMore: () => setIsLoadMoreData(prev => !prev) }),
        },
        {
            key: 'tab1',
            label: '전체',
            page: ({ saveScroll }) =>
                QuestionListItem({
                    category: 0,
                    inaList: inaList?.allList,
                    saveScroll,
                    setIsLoadDataMore: () => setIsLoadMoreData(prev => !prev),
                }),
        },
        {
            key: 'tab2',
            label: '보험금청구',
            page: ({ saveScroll }) =>
                QuestionListItem({
                    category: 1,
                    inaList: inaList?.insuranceClaimList,
                    saveScroll,
                    setIsLoadDataMore: () => setIsLoadMoreData(prev => !prev),
                }),
        },
        {
            key: 'tab3',
            label: '상품문의',
            page: ({ saveScroll }) =>
                QuestionListItem({
                    category: 2,
                    inaList: inaList?.productInquiryList,
                    saveScroll,
                    setIsLoadDataMore: () => setIsLoadMoreData(prev => !prev),
                }),
        },
        {
            key: 'tab4',
            label: '보장분석',
            page: ({ saveScroll }) =>
                QuestionListItem({
                    category: 3,
                    inaList: inaList?.guaranteeAnalysisList,
                    saveScroll,
                    setIsLoadDataMore: () => setIsLoadMoreData(prev => !prev),
                }),
        },
        {
            key: 'tab5',
            label: '병력문의',
            page: ({ saveScroll }) =>
                QuestionListItem({
                    category: 4,
                    inaList: inaList?.diseaseInquiryList,
                    saveScroll,
                    setIsLoadDataMore: () => setIsLoadMoreData(prev => !prev),
                }),
        },
        {
            key: 'tab6',
            label: '기타문의',
            page: ({ saveScroll }) =>
                QuestionListItem({
                    category: 5,
                    inaList: inaList?.etcInquiryList,
                    saveScroll,
                    setIsLoadDataMore: () => setIsLoadMoreData(prev => !prev),
                }),
        },
    ];

    return (
        <Container>
            <SwipeableTabView
                tab={currentTab}
                onChangeTab={setCurrentTab}
                renderScene={renderScene}
                activeColor={THEME_COLORS.default}
                flexTabBar={false}
                isLoadDataMore={isLoadMoreData}
            />
        </Container>
    );
};

const Container = styled.div`
    margin-top: 22px;
    padding-bottom: 85px;
    .react-swipeable-view-container > div {
        transform: translate3d(0, 0, 0);
    }
`;

export default QuestionList;
